import React, { useRef } from "react";
import { YHDrawer } from "@components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import { useLogModel } from "../logModel";


export function DetailDrawer() {
    const { drawerVisible: visible, setDrawerVisible, getSelectedRowData } = useLogModel();
    const onCancel = () => {
        setDrawerVisible(false);
    }
    const formRef = useRef<IYhFormRef>();
    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        disabled: true,
        initialValues: getSelectedRowData(),
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "分支",
                fieldName: "branch",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "版本",
                fieldName: "ver",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "启用",
                fieldName: "enable",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编码",
                fieldName: "code",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "名称",
                fieldName: "name",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "状态",
                fieldName: "status",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }
        ]
    };
    return (
        <YHDrawer
            {...{
                title: "应用信息",
                visible,
                onCancel,
                showFooter: false
            }}
        >
            {/*<DetailForm/>*/}
            <YhForm  {...formConfig} />
        </YHDrawer>
    )
}

/*

const DetailForm = () => {
    return (
        <Form
            labelCol={{span: 6}}
            wrapperCol={{span: 14}}
            layout="horizontal"
        >
            <Form.Item label="尺寸" name="size">
                <Radio.Group disabled={true}>
                    <Radio.Button value="small">小</Radio.Button>
                    <Radio.Button value="default">默认</Radio.Button>
                    <Radio.Button value="large">大</Radio.Button>
                </Radio.Group>
            </Form.Item>
            <Form.Item label="编码">
                <Input placeholder={"请输入"} disabled={true}/>
            </Form.Item>
            <Form.Item label="名称">
                <Select
                    disabled={true}
                    allowClear={true}
                    placeholder={"请选择"}
                >
                    <Select.Option value="demo">名称1</Select.Option>
                </Select>
            </Form.Item>
            <Form.Item label="类别">
                <TreeSelect
                    disabled={true}
                    allowClear={true}
                    placeholder={"选择"}
                    treeData={[
                        {title: '亮色', value: 'light', children: [{title: '管理类', value: 'bamboo'}]},
                    ]}
                />
            </Form.Item>
            <Form.Item label="级联选择">
                <Cascader
                    disabled={true}
                    placeholder={"选择"}
                    options={[
                        {
                            value: 'zhejiang',
                            label: '目录1',
                            children: [
                                {
                                    value: 'hangzhou',
                                    label: '目录2',
                                },
                            ],
                        },
                    ]}
                />
            </Form.Item>
            <Form.Item label="日期">
                <DatePicker
                    disabled={true}
                    allowClear={true}
                    placeholder={"请选择"}
                />
            </Form.Item>
            <Form.Item label="数字">
                <InputNumber
                    disabled={true}
                    placeholder={"请输入"}
                />
            </Form.Item>
            <Form.Item label="开关">
                <Switch disabled={true}/>
            </Form.Item>
        </Form>
    )
}
*/
